<template>
    <div loginpage data-layout-type="regular" :data-layout-width="layout.LayoutWidth">
        <header :data-position="layout.HeaderAlignmentPublicName">
            <media v-if="layout.HeaderImagePath" data-logo :url="state.layout.HeaderImagePath" alt="Layout Logo" aria-hidden="true" type="Image" />
        </header>
        <languageswitcher v-if="state.languages !== undefined && state.languages.length > 1" />
        <main>
            <transition name="slide" appear>
                <div data-container>
                    <div v-if="validationMessage !== ``" data-validation>
                        <div data-icon>
                            <font-awesome-icon aria-hidden="true" icon="exclamation-circle" />
                        </div>
                        <div data-text>
                            <strong role="alert" v-html="$sanitize(validationMessage)">{{ validationMessage }}</strong>
                        </div>
                    </div>
                </div>
            </transition>
            <div data-main>
                <form v-if="emailInviteMessage === ``" @submit.prevent>
                    <!-- this has an empty pseudo tag -->
                    <p data-welcome-text v-html="$sanitize(welcomeText || persgroepMessage)" :data-text-position="layout.TextAlignmentPublicName"></p>
                    
                    <div v-if="(loginType === `CodeEntry` || loginType === `CodeList`) && state.surveyInfo.performDpgConsent === undefined" row>
                        <label id="login-code-label" for="login-code"  v-html="loginLabel"></label>
                        <input
                            type="text"
                            id="login-code"
                            :placeholder="loginPlaceholder"
                            v-model="code"
                            autocomplete="one-time-code"
                            :data-has-value="code !== ``"
                            @keyup.enter="userWantsToLogin"
                            :disabled="state.global.showLoader"
                        />
                    </div>
                    <div v-if="[`EmailEntry`, `EmailList`, `EmailSignIn`].includes(loginType) || state.surveyInfo.performDpgConsent" row>
                        <label for="login-email">{{ this.$store.getters.textResource(`rs_login_email_label`) }}</label>
                        <input
                            type="email"
                            id="login-email"
                            :placeholder="this.$store.getters.textResource(`rs_email_placeholder`)"
                            v-model="email"
                            autocomplete="email"
                            :data-has-value="email !== ``"
                            @keyup.enter="userWantsToLogin"
                            :disabled="state.global.showLoader"
                        />
                    </div>
                    <div v-if="state.surveyInfo.loginCode2Label" row>
                        <label for="login-code">{{ state.surveyInfo.loginCode2Label }}</label>
                        <input
                            type="text"
                            id="login-code"
                            :placeholder="`${
                                (this.$store.getters.textResource(`rs_type`) + ` ` +  state.surveyInfo.loginCode2Label.toLowerCase() + ` ` + this.$store.getters.textResource(`rs_here`))
                            }`"
                            v-model="code2"
                            autocomplete="one-time-code"
                            :data-has-value="code2 !== ``"
                            @keyup.enter="userWantsToLogin"
                            :disabled="state.global.showLoader"
                        />
                    </div>
                    <div row>
                        <input
                            data-button
                            data-styling-type="secondary"
                            v-if="state.surveyInfo.performDpgConsent"
                            type="button"
                            id="persgroep_subscribe_button"
                            @click="userWantsToSubscribeToPersgroep"
                            :value="this.$store.getters.textResource(`rs_persgroep_i_want_to_subscribe`)"
                            :disabled="state.global.showLoader"
                        />
                        <input
                            data-button
                            data-styling-type="secondary"
                            type="button"
                            id="login-button"
                            v-else-if="loginType !== `EmailSignIn`"
                            :value="this.$store.getters.textResource(`rs_login`)"
                            @click="userWantsToLogin"
                            :disabled="state.global.showLoader"
                        />
                        <input
                            data-button
                            data-styling-type="secondary"
                            :disabled="state.global.showLoader"
                            type="button"
                            v-else
                            id="request-email-button"
                            :value="this.$store.getters.textResource(`rs_request_email`)"
                            @click="userWantsToLogin"
                        />
                    </div>
                </form>
                <div v-else>
                    <p data-email-message>{{ emailInviteMessage }}</p>
                </div>
            </div>
        </main>
        <footer v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
             <a :href="state.surveyInfo.culture === `nl-NL` ? `https://welcome.crowdtech.com/pdc` : `https://welcome.crowdtech.com/pbc`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
        </footer>
    </div>
</template>

<script>
import methods from "@/global/methods.js";
import media from "@/components/Media.vue";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import apivalidation from "@/global/apivalidation.js";
import store from "@/store/store";
import languageswitcher from "@/components/LanguageSwitcher.vue";

Vue.use(VueSanitize, store.state.global.allowedHtml);

export default {
    name: `loginpage-view`,
    components: {
        media,
        languageswitcher
    },
    data() {
        return {
            code: ``,
            code2: ``,
            email: ``,
            consentId: ``,
            persgroepMessage: ``,
            validationMessage: ``,
            emailInviteMessage: ``,
        };
    },
    computed: {
        loginLabel: function () {
            if(this.loginType === `CodeList` && this.state.surveyInfo.loginCode2Label !== ``) {
                return this.state.surveyInfo.loginCode1Label;
            }
            else {
                return this.$store.getters.textResource(`rs_login_code_label`);
            }
        },
        loginPlaceholder: function () {
            if(this.loginType === `CodeList` && this.state.surveyInfo.loginCode1Label !== ``)
            {
                return (this.$store.getters.textResource(`rs_type`) + ` ` +  this.state.surveyInfo.loginCode1Label.toLowerCase() + ` ` + this.$store.getters.textResource(`rs_here`));
            }
            else {
                return this.$store.getters.textResource(`rs_login_placeholder`);
            }
        },
        state: function () {
            return this.$store.state;
        },
        loginType: function () {
            return this.state.surveyInfo.loginType;
        },
        welcomeText: function () {
            return this.$route.params.welcomeText;
        },
        layout: function () {
            return this.state.layout;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
    },
    methods: {
        userWantsToLogin: function () {
            let queryParams = this.state.surveyInfo.queryParams;
            let data = {
                surveyId: this.state.surveyInfo.surveyId,
            };

            if ([`EmailEntry`, `EmailList`, `EmailSignIn`].includes(this.loginType)) data.code = this.email;
            if ([`CodeEntry`, `CodeList`].includes(this.loginType)) data.code = this.code;
            if (this.state.surveyInfo.loginCode2Label !== ``) data.code2 = this.code2;
            if (queryParams && Object.keys(queryParams).length > 0) data.queryParameters = queryParams;

            // To prevent AJAX call spam
            document.activeElement.blur();
            
            methods.xhr({
                url: this.state.surveyInfo.authenticationUrl,
                setSurveyId: true,
                data: data,
                callback: (xhr) => {
                    let response = JSON.parse(xhr.responseText);

                    response = apivalidation.validate(response, `login`);
                    apivalidation.validateQuestionObj(response.actionObject);
                    
                    let currentCulture = this.state.surveyInfo.culture || this.state.surveyInfo.queryParams.culture;
                    let newCulture = response.culture;
                    this.validationMessage = ``;

                    this.updateText(currentCulture, newCulture);

                    if (response.action === `DisplayText`) {
                        this.emailInviteMessage = response.message;

                        this.$store.commit(`changeGlobal`, {
                            variableName: `showLoader`,
                            newValue: false,
                        });
                    } else if (response.action === `ShowError`) {
                        this.validationMessage = response.message || response.actionObject.message;
                        this.$store.commit(`changeGlobal`, {
                            variableName: `showLoader`,
                            newValue: false,
                        });
                    } else if (response.action === `Redirect`) {
                        // If we redirect, we do need a loader to show until the redirect is finished
                        this.$store.commit(`changeGlobal`, {
                            variableName: `showLoader`,
                            newValue: true,
                        });
                        location.replace(response.actionObject.redirectUrl);
                    } else if (response.action === `SurveyEnd`) {
                        this.$router.replace({
                            name: `Endpage`,
                            params: {
                                message: response.actionObject.message,
                            },
                        });
                    } 
                    else if (response.action === `ShowRestartPage`) {
                        this.$store.commit(`addSurveyInfo`, response);
                        this.$router.replace({
                            name: `RestartPage`,
                        });
                    }
                    else {
                        this.$store.commit(`addSurveyInfo`, response);
                        this.$store.commit(`addPageData`, {
                            page: response.actionObject,
                        });
                        this.$router.replace(`Questionnaire`);
                    }
                },
            });
        },
        updateText(currentCulture, newCulture) {
            if (newCulture !== undefined && newCulture !== null && currentCulture !== newCulture) {
                this.$store.dispatch("loadText", newCulture);
            }
        },
        // Maatwerk voor Persgroep
        userWantsToSubscribeToPersgroep(){
             methods.xhr({
                url: `${process.env.VUE_APP_CUSTOM2_URL}/api/persgroep/Consent?apiRequest=postConsent&email=${this.email}&id=${this.consentId}`,
                type: `GET`,
                callback: (xhr) => {
                    let response = JSON.parse(JSON.parse(xhr.responseText));

                    this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });

                    if(response.messages) {
                        const emailRegex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        
                        if(this.email === ``) this.validationMessage = this.$store.getters.textResource(`rs_dpg_email_required`);
                        else if(!emailRegex.test(this.email)) this.validationMessage = this.$store.getters.textResource(`rs_dpg_wrong_email_format`);
                        else this.validationMessage = this.$store.getters.textResource(`rs_dpg_something_went_wrong`);
                    } else {
                        this.userWantsToLogin();
                    }
                }
             });
        },
        // Maatwerk voor Persgroep
        getConsentIdFromPersGroep(){
            methods.xhr({
                url: `${process.env.VUE_APP_CUSTOM2_URL}/api/persgroep/Consent?apiRequest=getConsent&email=mwm2.nl&id=78395ac7-9981-400d-8fe7-5d54a4b87c1e`,
                type: `GET`,
                withCredentials: false,
                callback: (xhr) => {
                    let response = JSON.parse(JSON.parse(xhr.responseText));
                    
                    this.consentId = response.id;
                    this.persgroepMessage = response.text;
                    
                    this.$store.commit(`changeGlobal`, {
                        variableName: `showLoader`,
                        newValue: false,
                    });
                }
            });
        }
    },
    created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });

        if(this.state.surveyInfo.performDpgConsent) this.getConsentIdFromPersGroep();
    },
};
</script>

<style lang="scss" scoped>
[loginpage] {
    main {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 500px;
    }

    [data-welcome-text] {
        width: 100%;
        margin: 0 0 25px 0;
        text-align: center;

        &:empty {
            display: none;
        }

        &[data-text-position="Left"] {
            text-align: left;
        }

        &[data-text-position="Right"] {
            text-align: right;
        }

        &[data-text-position="Center"] {
            text-align: center;
        }
    }

    [data-email-message] {
        margin: 16px;
    }

    [data-container] {
        height: 100%;
        max-height: 120px;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
    }

    [data-validation] {
        text-align: center;
        display: flex;
        flex-wrap: nowrap;
        border-radius: 10px;
        justify-content: space-evenly;
        align-items: center;
        background: white;
        width: 100%;
        max-width: 350px;

        [data-icon] {
            flex-basis: 25%;
            width: 100%;
            color: #e41717;
            font-size: 1.3em;
        }

        [data-text] {
            font-size: 15px;
            flex-basis: 75%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(228, 23, 23, 0.15);
            width: 100%;
            height: 100%;
            color: rgba(0, 0, 0, 0.7);
            border-radius: 0 10px 10px 0;
            padding: 15px;
        }
    }

    [data-main] {
        padding: 10px;
    }

    form {
        max-width: 500px;
        margin: auto;
        width: 100%;
        padding: 20px 25px;

        [row] {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 0 25px;

            label {
                align-self: flex-start;
                margin-bottom: 12px;
            }

            [data-button] {
                margin: 9px 0 -25px;
            }
        }
    }
}

.slide-enter-active {
    transition: opacity 1s;
    transition: 0.2s ease-out;
    transition-delay: 2s;
}

.slide-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateY(50%);
}
</style>